module.exports = __webpack_public_path__ + "static/media/2-1.e857d330.svg";